import { render, staticRenderFns } from "./CreateChickenleg.vue?vue&type=template&id=a9a91034"
import script from "./CreateChickenleg.vue?vue&type=script&lang=js"
export * from "./CreateChickenleg.vue?vue&type=script&lang=js"
import style0 from "./CreateChickenleg.vue?vue&type=style&index=0&id=a9a91034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports